export const Work = [
  {
    id: 21,
    name: "Vanakkam DSA",
    description:
      "A Tamil cohort-based DSA and interview preparation platform founded by Hareesh Rajendran. 1000+ paying students across 7 cohorts.",
    tags: ["Tamil", "DSA", "Education"],
    demo: "https://vanakkamdsa.com",
    github: "",
    image: "/images/vanakkam-dsa-logo.png"
  },
  {
    id: 20,
    name: "Cleverhire",
    description:
      "AI-assisted recruitment platform with ATS, an autonomous AI interviewer, recruiter copilot and anti-cheating capabilities.",
    tags: ["AI", "ATS", "Product"],
    demo: "https://cleverhire.ai",
    github: "",
    image: "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2FWIP.jpg?alt=media&token=d384a63d-39f9-4c55-8cea-e39e2c52de4c"
  },
  {
    id: 19,
    name: "Timesheet Tracker",
    description:
      "Shipped in two weeks at Highbrow Technology and grown to 500+ users.",
    tags: ["Frontend", "Highbrow"],
    demo: "",
    github: "",
    image: "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2FWIP.jpg?alt=media&token=d384a63d-39f9-4c55-8cea-e39e2c52de4c"
  },
  {
    id: 22,
    name: "DSA in Java",
    description:
      "Open-source repository of Data Structures and Algorithms implementations in Java.",
    tags: ["Java", "DSA", "Open Source"],
    demo: "https://github.com/hareesh-r/Data-Structures-And-Algorithms-DSA-in-Java",
    github: "https://github.com/hareesh-r/Data-Structures-And-Algorithms-DSA-in-Java",
    image: "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2FWIP.jpg?alt=media&token=d384a63d-39f9-4c55-8cea-e39e2c52de4c"
  },
  {
    id: 17,
    name: "KryptoGiffy",
    description:
      "This platform allows you to perform transactions via Blockchain by using Ethereum mainnet.Prerequsite : Web3.0 Wallet.",
    tags: ["Ropsen", "Goerli", "Ethereum", "Web 3.0"],

    demo: "https://kryptogiffy.web.app/",
    github: "https://github.com/hareesh-r/KryptoGiffy",
    image: "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fkryptogiffy.jpg?alt=media&token=b642f131-cdda-4378-9d2b-7f8770b1e671"
  },{
    id: 16,
    name: "Graphical Password Authentication",
    description:
      "Users can set passwords using images and their sequence using this project, which implements the same concept for password authentication as recapcha (checks for Human). I have presented the Live Demo for Smart India Hackathon",
    tags: ["SIH", "Security", "API", "MongoDB"],

    demo: "https://github.com/hareesh-r/Graphical-password-authentication",
    github: "https://github.com/hareesh-r/Graphical-password-authentication",
    image: "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2FWIP.jpg?alt=media&token=d384a63d-39f9-4c55-8cea-e39e2c52de4c"
  },{
    id: 18,
    name: "Breach Checker",
    description:
      "This website checks if your passwords or critical information has been leaked anywhere in the internet or not. This website is completely free , secure and not vulnerable to attacks like SQL Injection, XSS, etc.",
    tags: ["HIBP", "RockYou2021", "APIs", "Particle.JS"],

    demo: "https://breachchecker.web.app/",
    github: "https://github.com/hareesh-r/password-breach-checker",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2FBreach.jpg?alt=media&token=cafe9666-18c6-403d-919c-c6771c44b9fc"
  },{
    id: 1,
    name: "Crypto King",
    description:
      "Crypto king is a crypto infomercial web app that displays market and Top 100 crypto currency data, as well as relevant news and information about crypto exchanges.",
    tags: ["React", "Crypto", "Coinranking API", "Redux"],

    demo: "https://cryptoking.web.app/",
    github: "https://github.com/hareesh-r/cryptoking",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fcryptoking.jpg?alt=media&token=250872db-0997-4e38-9676-08c1d69242a9"
  },
  {
    id: 2,
    name: "Internshala-frontend",
    description:
      "This web application for an internship application was created in 3 hours and is identical to the homepage of internshala.com",
    tags: ["React", "HTML", "CSS"],

    demo: "https://internshala-frontend.web.app/",
    github: "https://github.com/hareesh-r/internshala-frontend",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Finternshala-frontend.jpg?alt=media&token=6111c43a-0ae0-4130-8e52-4897b042a43d"
  },
  {
    id: 3,
    name: "Stock-information",
    description:
      "This is a stock market information web application that will provide infographics on real-time stock market data from well-known stocks in daily, weekly, and monthly views, as well as extra stock information packed with a search for specific stock feature.",
    tags: ["React", "API", "Stocks", "AlphaVantage", "Chart.js"],

    demo: "https://stock-information.web.app/",
    github: "https://github.com/hareesh-r/stock-info",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fstock-info.jpg?alt=media&token=e676df7e-fdd5-42be-9ef2-f5ba640320e4"
  },
  {
    id: 4,
    name: "Acoustic Music",
    description:
      "This is a Spotify web app that allows you to listen to most of the songs if you have a premium membership; otherwise, you can listen to a 30-second song preview.",
    tags: ["React", "Spotify API", "Spotify Authentication"],

    demo: "https://acousticmusic.web.app/",
    github: "https://github.com/hareesh-r/acoustic-music",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Facoustic.jpg?alt=media&token=08d3adfc-c468-4f34-ab83-1a5fefda41d5"
  },
  {
    id: 5,
    name: "Weather Man",
    description:
      "It's a simple weather app featuring real-time data from 5 well-known locations, as well as a detailed Real-Time Prediction Chart developed with OpenWeatherAPI. You can also search for your desired city and get facts, as well as a dynamic backdrop image and real-time chart.",
    tags: ["React", "Open weather API", "Chart.js"],

    demo: "https://weather-man-hareesh.web.app/",
    github: "https://github.com/hareesh-r/weather-man",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fweather.jpg?alt=media&token=56582d0b-fe15-4e53-a9ce-349c0f17e7f8"
  },
  {
    id: 6,
    name: "Eco Ville - Geek Social",
    description:
      "Climate change has always been a persistent and catastrophic issue, and the problem with addressing it is that there is no effective way to determine whether one's contribution to environmental protection is effective and We built a potential solution",
    tags: ["React Native", "Android", "Adobe XD"],

    demo: "https://www.youtube.com/watch?v=40ZY_vaVn3w",
    github: "https://www.youtube.com/watch?v=40ZY_vaVn3w",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2FEcoVille.jpg?alt=media&token=ee509486-64bd-4aa4-8bc1-6577f74338f5"
  },
  {
    id: 7,
    name: "ComebackAlums V2.0",
    description:
      "CSI Sponsored web development competition winning Project and Personal Favorite",
    tags: ["React", "Firebase", "Material UI"],

    demo: "https://comebackalums.web.app/",
    github: "https://github.com/hareesh-r/comebackalums2.0",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fcomeback.jpg?alt=media&token=8fc2dcf5-1696-4626-a52b-c2625452a8f2"
  },
  {
    id: 8,
    name: "Google Clone",
    description:
      "Clone of Google With dark mode functionality, built with Google Custom Search API and ReactJS.",
    tags: ["React", "Google Search API", "CSS", "HTML"],

    demo: "https://gooogle-hareesh.web.app/",
    github: "https://github.com/hareesh-r/google-hareesh",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fgoogle.jpg?alt=media&token=e1aa6175-55ca-4307-9e7a-1811d42060ca"
  },
  {
    id: 9,
    name: "Netflix Frontend Clone",
    description:
      "Netflix frontend clone with React JS and Firebase Backend with TMDB API",
    tags: ["React", "TMDB API", "CSS", "Firebase"],

    demo: "https://netflix-hareesh.web.app/",
    github: "https://github.com/hareesh-r/netflix-hareesh",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fnetflix.jpg?alt=media&token=61b9542d-d38b-44bc-b4dd-8199a1a42f4a"
  },
  {
    id: 10,
    name: "JioFi-Battery-Notification",
    description:
      "This is my own code to fix a real-world problem with my JioFi's (Portable Hotspot) battery bulging due to overcharging and cutting out owing to low battery.",
    tags: ["Python", "Python notification", "selenium"],

    demo: "https://github.com/hareesh-r/JioFi-Battery-Notification",
    github: "https://github.com/hareesh-r/JioFi-Battery-Notification",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fjiofi.jpg?alt=media&token=433dd834-4a6f-4443-8322-4d0ed1aeb2ca"
  },
  {
    id: 11,
    name: "Mineral Drop",
    description:
      "This is the website I built for Mineral Drop as an intern. It serves as a landing page for the startup.",
    tags: ["HTML", "CSS", "Bootstrap"],

    demo: "https://mineraldrop.in/",
    github: "https://github.com/hareesh-r/mdrop",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fmineraldrop.jpg?alt=media&token=d98dc2e4-16b0-4cba-8083-e81e29052bf4"
  },
  {
    id: 12,
    name: "Facial Expression Recognition",
    description:
      "Tensor flow based facial expression recognition project constructed with a package called Keras and an 8 layers neural network that can recognise 7 expressions.",
    tags: ["Python 3", "CNN", "Deep Learning", "Open CV"],

    demo: "https://github.com/hareesh-r/Facial-Expression-Recognition-Keras",
    github: "https://github.com/hareesh-r/Facial-Expression-Recognition-Keras",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Fface.jpg?alt=media&token=c85f8e04-3c8d-4c58-82cc-0e68a7df5378"
  },
  {
    id: 13,
    name: "Tweet Bot",
    description:
      "If you have a legitimate account, this is the tweet bot that can post tweets indefinitely.",
    tags: ["Python", "Selenium", "Bot"],

    demo: "https://github.com/hareesh-r/tweetbot",
    github: "https://github.com/hareesh-r/tweetbot",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Ftweet.jpg?alt=media&token=fe7b2aec-1317-40a8-aee6-dac343050ba2"
  },
  {
    id: 14,
    name: "File-Seperator",
    description:
      "It's a Python-based file segregator that separates files into different folders based on their type, allowing you to organise your files in seconds and helping people with OCD by cleaning the cutter. ",
    tags: ["OS", "Python", "Utility", "Real Time"],

    demo: "https://github.com/hareesh-r/File-Seperator",
    github: "https://github.com/hareesh-r/File-Seperator",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Ffileseperator.jpg?alt=media&token=06a64da8-2da2-4bf8-8232-ba3ca50e39bc"
  },
  {
    id: 15,
    name: "instagram-login-automation",
    description:
      "Send a message to anyone with two options. In a variety of languages (120+), wish them a happy birthday. Annoy them by sending them the same message N times.",
    tags: ["Instagram", "Selenium", "Python"],

    demo: "https://github.com/hareesh-r",
    github: "https://github.com/hareesh-r",
    image : "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/projects%2Ffileseperator.jpg?alt=media&token=06a64da8-2da2-4bf8-8232-ba3ca50e39bc"
  },
];
